











































































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { AnestesistaHospital } from '@/types/_'
import EventBus from '@/plugins/EventBus'
import SolicitacaoCirurgiaStore from '../SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'

@Component
export default class ComponentModalBackofficeAnestesistas extends Vue {
  $refs: { getInputSearch: HTMLInputElement }

  anestesistasTableHeader: any[] = [
    { text: 'Nome', align: 'left', value: 'anestesistaNome', sortable: false },
    { text: 'CRM', align: 'left', value: 'anestesistaCrm', sortable: false },
    { text: 'CNPJ', align: 'left', value: 'anestesistaDocumento', sortable: false },
    { text: 'Vinculado ao hospital?', align: 'center', value: '', sortable: false },
  ]

  loadAnestesistas: boolean = false
  get loadingAnestesistas() { return this.loadAnestesistas }
  set loadingAnestesistas(value: boolean) { this.loadAnestesistas = value }

  get getInputSearch() { return this.getBackofficeGlobalStore.anestesistaSearchText }
  set getInputSearch(value: string) { this.getBackofficeGlobalStore.setAnestesistaSearchText(value) }

  get getAnestesistasApi() {
    return this.getBackofficeGlobalStore.anestesistas || []
  }

  get getPagina() {
    return this.getBackofficeGlobalStore.pagina
  }

  set getPagina(value: number) {
    this.getBackofficeGlobalStore.setPagina(value)
  }

  get getQtdPorPagina() {
    return this.getBackofficeGlobalStore.qtdPorPagina
  }

  set getQtdPorPagina(value: number) {
    this.getBackofficeGlobalStore.setQtdPorPagina(value)
  }

  get getTotalAnestesistas() {
    return this.getBackofficeGlobalStore.totalAnestesistas
  }

  get anestesistasLength() {
    return Math.ceil(this.getTotalAnestesistas / this.getQtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  async getResults(pagina: number) {
    this.loadingAnestesistas = true
    this.getPagina = pagina
    await this.getBackofficeGlobalStore.getAllAnestesistasByHospitalId()
    this.loadingAnestesistas = false
  }

  selected: AnestesistaHospital = { id: '', nome: '', crm: '', temVinculoHospital: true }
  get selectedAnestesista() { return this.selected }
  set selectedAnestesista(value: AnestesistaHospital) { this.selected = value }

  loadConfirmar: boolean = false
  get loadingConfirmar() { return this.loadConfirmar }
  set loadingConfirmar(value: boolean) { this.loadConfirmar = value }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get showModalAnestesistas() { return this.getBackofficeGlobalStore.modal.listaDeAnestesistas }
  set showModalAnestesistas(value: boolean) { this.getBackofficeGlobalStore.setModal({ name: 'listaDeAnestesistas', value }) }

  debounce = _.debounce(input => this.getBackofficeGlobalStore.getAllAnestesistasByHospitalId(), 700)

  search() {
    if (this.getInputSearch.length === 0) this.resetSearch()
    if (this.getInputSearch.length > 2) {
      this.getBackofficeGlobalStore.clearPagination()
      this.debounce(this.getInputSearch)
    }
  }

  resetSearch() {
    this.getInputSearch = ''
    this.getBackofficeGlobalStore.clearPagination()
    this.getBackofficeGlobalStore.clearAnestesistas()
  }

  async confirmar() {
    this.loadingConfirmar = true
    const request = await this.getBackofficeGlobalStore.resolvePendenciaDeAnestesista({ anestesistaId: this.selectedAnestesista.id })

    if (request.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Anestesista alterado com sucesso!', icon: 'done', color: '#2E7D32' })
      this.showModalAnestesistas = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Ocorreu um erro na requisição.', icon: 'warning', color: '#C62828' })
    }
    this.loadingConfirmar = false
  }

  @Watch('showModalAnestesistas')
  onChangeShowModalAnestesistas(value: boolean) {
    setTimeout(() => {
      if (value) {
        this.$refs.getInputSearch.focus()
      } else {
        this.$refs.getInputSearch.blur()
        this.getInputSearch = ''
        this.getBackofficeGlobalStore.clearPagination()
        this.getBackofficeGlobalStore.clearAnestesistas()
        this.selected = { id: '', nome: '', crm: '', temVinculoHospital: true }
        this.getBackofficeGlobalStore.setModal({ name: 'listaDeAnestesistas', value: false })
      }
    }, 100)
  }
}

